module.exports = __webpack_public_path__ + "static/img/about-img-03.c9084ff.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-img-03.jpeg
// module id = gbLg
// module chunks = 0